module.exports = __webpack_public_path__ + "static/media/speedometer.b62fdef1.svg";